/* ==========================================================================
   Vision Attire — shared behaviour
   No framework. Everything here is either progressive enhancement or a
   feature the audit identified as revenue-critical.
   ========================================================================== */
(() => {
  'use strict';

  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const DAY = 86400000;

  /* --- analytics ----------------------------------------------------------
     vaTrack() is defined in the page head by build.py and only sends on the
     client's own domain. settle() waits until someone stops typing, so a hip
     measurement or a show date isn't sent a keystroke at a time.
     ---------------------------------------------------------------------- */
  const vaSend = (n, p) => { if (window.vaTrack) window.vaTrack(n, p || {}); };
  const settled = {};
  const settle = (n, p) => {
    const key = JSON.stringify(p), last = settled[n] || {};
    clearTimeout(last.t);
    settled[n] = { key: last.key, t: setTimeout(() => {
      if (settled[n].key === key) return;
      settled[n].key = key; vaSend(n, p);
    }, 1200) };
  };
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href]');
    if (!a) return;
    const href = a.getAttribute('href');
    const where = a.closest('.nav') ? 'nav' : a.closest('.drawer') ? 'menu' : a.closest('.foot') ? 'footer' : 'page';
    if (href.startsWith('mailto:')) vaSend('contact_click', { method: 'email', location: where });
    else if (href.startsWith('tel:')) vaSend('contact_click', { method: 'phone', location: where });
    else if (/^(\/pages\/)?custom(\.html|$|[?#])/.test(href)) vaSend('cta_click', { cta: 'build_custom', location: where });
    else if (/^(product-[a-z-]+\.html|\/collections\/[a-z-]+$|\/collections\/[a-z-]+#)/.test(href) && where === 'page' && !a.closest('[data-product]'))
      vaSend('select_item', { item_list_name: location.pathname.replace(/^\/|\.html$/g, '') || 'index',
        items: [{ item_id: href.split('#')[1] || href.replace('.html', ''), item_name: a.textContent.trim().replace(/\s+/g, ' ').slice(0, 80) }] });
  });

  /* --- mobile drawer ---------------------------------------------------- */
  const burger = $('.burger');
  const drawer = $('#drawer');
  const nav = $('.nav');
  if (nav) new ResizeObserver(() => document.documentElement.style.setProperty('--site-nav-h', nav.offsetHeight + 'px')).observe(nav);
  const helpMenu = $('.nav__group');
  if (helpMenu) {
    document.addEventListener('click', e => {if (!helpMenu.contains(e.target)) helpMenu.open = false;});
    document.addEventListener('keydown', e => {if (e.key === 'Escape' && helpMenu.open) {helpMenu.open = false; $('summary', helpMenu).focus();}});
    helpMenu.addEventListener('focusout', () => requestAnimationFrame(() => {if (!helpMenu.contains(document.activeElement)) helpMenu.open = false;}));
  }
  if (burger && drawer) {
    burger.addEventListener('click', () => {
      const open = burger.getAttribute('aria-expanded') === 'true';
      burger.setAttribute('aria-expanded', String(!open));
      drawer.toggleAttribute('data-open', !open);
      if (!open) {
        document.documentElement.style.setProperty('--site-nav-bottom', nav.getBoundingClientRect().bottom + 'px');
        drawer.scrollTop = 0;
        $('a', drawer).focus({preventScroll:true});
      } else burger.focus();
      document.body.style.overflow = open ? '' : 'hidden';
    });
    drawer.addEventListener('click', e => {
      if (e.target.tagName === 'A') burger.click();
    });
    addEventListener('keydown', e => {
      if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') burger.click();
      if (e.key === 'Tab' && burger.getAttribute('aria-expanded') === 'true') {
        const links = $$('a', drawer), first = links[0], last = links[links.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === burger)) {e.preventDefault();last.focus();}
        else if (!e.shiftKey && document.activeElement === last) {e.preventDefault();burger.focus();}
        else if (!e.shiftKey && document.activeElement === burger) {e.preventDefault();first.focus();}
      }
    });
    matchMedia('(min-width:1060px)').addEventListener('change', e => {if(e.matches && burger.getAttribute('aria-expanded')==='true')burger.click();});
  }

  /* --- reveal on scroll ------------------------------------------------- */
  const reveals = $$('[data-reveal]');
  if (reveals.length && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => {
        if (!en.isIntersecting) return;
        const d = en.target.dataset.revealDelay || 0;
        setTimeout(() => en.target.classList.add('is-in'), +d);
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    reveals.forEach(el => io.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('is-in'));
  }

  /* --- accent switcher --------------------------------------------------
     Andy asked whether to add a colour to the black/white/grey and said the
     red was too harsh. Rather than answer in an email, the options are live
     against the real product. Choice persists across pages.
     ---------------------------------------------------------------------- */
  const bar = $('#accbar');
  if (bar) {
    const KEY = 'va-accent-2';  // bumped 5 Oct 2026 so saved bronze picks don't hide the new teal
    const HIDE = 'va-accent-hidden';
    const set = (v) => {
      document.documentElement.dataset.accent = v;
      try { localStorage.setItem(KEY, v); } catch {}
      $$('button[data-acc]', bar).forEach(b =>
        b.setAttribute('aria-pressed', String(b.dataset.acc === v)));
    };
    // A ?accent= in the URL wins over the saved choice, so a single link can
    // open the site in one specific colour. Used for the bronze/blue decision.
    const VALID = ['teal','bronze','deepblue','electric','oxblood','orange','red','none'];
    let saved = 'teal';
    try { saved = localStorage.getItem(KEY) || 'teal'; } catch {}
    const fromUrl = new URLSearchParams(location.search).get('accent');
    if (fromUrl && VALID.includes(fromUrl)) saved = fromUrl;
    set(saved);
    let hidden = false;
    try { hidden = localStorage.getItem(HIDE) === '1'; } catch {}
    if (!hidden) bar.hidden = false;
    $$('button[data-acc]', bar).forEach(b =>
      b.addEventListener('click', () => set(b.dataset.acc)));
    $('[data-close]', bar).addEventListener('click', () => {
      bar.hidden = true;
      try { localStorage.setItem(HIDE, '1'); } catch {}
    });
  }

  /* --- data ------------------------------------------------------------- */
  let SITE = null;
  const siteReady = fetch(VA_DATA('assets/data/site.json'))
    .then(r => r.json()).then(VA_FIX)
    .then(d => (SITE = d))
    .catch(() => null);

  /* --- business-day helpers --------------------------------------------- */
  const addBusinessDays = (from, n) => {
    const d = new Date(from);
    let left = n;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) left--;
    }
    return d;
  };
  const fmt = (d) => d.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
  const startOfDay = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; };

  /* --- delivery calculator ----------------------------------------------
     The single highest-value thing in the build. Three of the sixteen DMs
     Andy sent were a competitor asking whether shorts land before their show.
     Answers with an estimate and a stated buffer — never a guaranteed date.
     ---------------------------------------------------------------------- */
  async function initCalc(form) {
    await siteReady;
    if (!SITE) return;
    const T = SITE.turnaround, S = SITE.shipping;
    const out = $('[data-calc-out]', form) || $(form.dataset.calcOut);
    if (!out) return;

    // Every region select is filled from site.json rather than its own markup,
    // so adding a country is a data edit in one place instead of five pages.
    const sel = $('[name=region]', form);
    if (sel && !sel.dataset.filled) {
      const au = [...sel.options].filter(o => o.value.startsWith('AU-'));
      sel.innerHTML = '';
      au.forEach(o => sel.add(o));
      S.international.regions.forEach(r => sel.add(new Option(r.name, r.name)));
      sel.dataset.filled = '1';
    }

    const regionDays = (region) => {
      if (region === 'AU-standard') return [S.standardDaysMin, S.standardDaysMax];
      if (region === 'AU-express')  return [S.expressDaysMin, S.expressDaysMax];
      const r = S.international.regions.find(x => x.name === region);
      return r ? [r.daysMin, r.daysMax] : [S.standardDaysMin, S.standardDaysMax];
    };

    function run() {
      const showVal = $('[name=showDate]', form).value;
      const type    = $('[name=orderType]', form).value;
      const region  = $('[name=region]', form).value;
      if (!showVal) { out.hidden = true; return; }

      const today = startOfDay(new Date());
      const show  = startOfDay(new Date(showVal + 'T00:00:00'));
      const daysAvailable = Math.round((show - today) / DAY);

      if (daysAvailable < 0) {
        out.hidden = false;
        out.dataset.verdict = 'no';
        out.innerHTML = `<div class="calc__verdict">That date has already passed</div>
          <p class="small muted">Pick your show date and we'll work back from it.</p>`;
        return;
      }

      const [shipMin, shipMax] = regionDays(region);
      let leadMin, leadMax, leadLabel, readyFrom;

      if (type === 'instock') {
        leadMin = T.inStockDispatchDaysMin;
        leadMax = T.inStockDispatchDaysMax;
        leadLabel = `Dispatched in ${leadMin}–${leadMax} business days`;
        readyFrom = 'the day you order';
      } else if (type === 'rush') {
        leadMin = T.mockupTurnaroundDays + T.rushWeeksMin * 7;
        leadMax = T.mockupTurnaroundDays + 3 + T.rushWeeksMax * 7;
        leadLabel = `Mockup in ~${T.mockupTurnaroundDays} business days, then ${T.rushWeeksMin}–${T.rushWeeksMax} weeks from your approval`;
        readyFrom = 'mockup approval';
      } else {
        leadMin = T.mockupTurnaroundDays + T.customWeeksMin * 7;
        leadMax = T.mockupTurnaroundDays + 3 + T.customWeeksMax * 7;
        leadLabel = `Mockup in ~${T.mockupTurnaroundDays} business days, then ${T.customWeeksMin}–${T.customWeeksMax} weeks from your approval`;
        readyFrom = 'mockup approval';
      }

      const totalMax = leadMax + shipMax;
      // Buffer scales with the job. A week of contingency is right on a six-week
      // custom build and absurd on a two-day dispatch — a flat week would tell
      // someone ten days out that an in-stock order is risky, which it isn't.
      const buffer   = Math.min(T.bufferDays, Math.max(3, Math.ceil(totalMax * 0.25)));
      const required = totalMax + buffer;
      const arriveMin = addBusinessDays(today, leadMin + shipMin);
      const arriveMax = addBusinessDays(today, leadMax + shipMax);

      let verdict, head, note;
      if (type !== 'instock' && daysAvailable < T.cutoffWeeks * 7 && type === 'custom') {
        verdict = 'no';
        head = "Too close for a standard custom order";
        note = `Our cut-off for custom is ${T.cutoffWeeks} weeks out, and your show is ${daysAvailable} days away. `
             + `A rush order may still work, or take a look at what's in stock — that ships in ${T.inStockDispatchDaysMin}–${T.inStockDispatchDaysMax} business days.`;
      } else if (daysAvailable >= required) {
        verdict = 'yes';
        head = 'Yes — that works';
        note = `You've got ${daysAvailable} days. We estimate ${totalMax} days end to end, which leaves about ${daysAvailable - totalMax} days spare.`;
      } else if (daysAvailable >= totalMax) {
        verdict = 'tight';
        head = "It should make it, but it's tight";
        note = `You've got ${daysAvailable} days and we estimate ${totalMax}. That's inside our estimate but there's no room if anything slips. `
             + `Call us before you order and we'll tell you honestly.`;
      } else {
        verdict = 'no';
        head = "Not in time, going by our estimates";
        note = `You've got ${daysAvailable} days and we estimate ${totalMax}. We'd rather say so now than take the order. `
             + (type === 'custom' ? 'Try a rush order, or something in stock.' : 'Have a look at what we hold in stock.');
      }

      out.hidden = false;
      out.dataset.verdict = verdict;
      settle('delivery_check', { order_type: type, verdict, days_to_show: daysAvailable });
      out.innerHTML = `
        <div class="calc__verdict">${head}</div>
        <p class="small" style="color:var(--ink-2)">${note}</p>
        <div class="calc__rows">
          <div><span>Estimated arrival</span><b>${fmt(arriveMin)} – ${fmt(arriveMax)}</b></div>
          <div><span>Your show</span><b>${fmt(show)}</b></div>
          <div><span>Production</span><b>${leadLabel}</b></div>
          <div><span>Shipping</span><b>${shipMin}–${shipMax} business days</b></div>
        </div>
        <p class="hint mt-1">These are estimates with a ${buffer}-day buffer built in, counted from ${readyFrom}. They are not guaranteed arrival dates.</p>`;
    }

    $$('input, select', form).forEach(el => el.addEventListener('change', run));
    $$('input[type=date]', form).forEach(el => el.addEventListener('input', run));
    form.addEventListener('submit', e => { e.preventDefault(); run(); });

    // Can't order for a show in the past.
    const dateEl = $('[name=showDate]', form);
    if (dateEl && !dateEl.min) dateEl.min = new Date().toISOString().slice(0, 10);
    run();
  }
  $$('[data-calc]').forEach(initCalc);
  // The custom builder injects its own calculator after this has already run,
  // so it needs a way back in. Without this the show-date check inside the
  // builder never binds — three of the sixteen DMs were that exact question.
  window.__vaInitCalc = (el) => { if (el) initCalc(el); };

  /* --- size finder -------------------------------------------------------
     Andy's division advice was trapped in the DMs. Three of the sixteen were
     a first-timer asking what size they are.
     ---------------------------------------------------------------------- */
  async function initSizer(form) {
    await siteReady;
    if (!SITE) return;
    const Z = SITE.sizing;
    const out = $('[data-size-out]', form);
    if (!out) return;

    function run() {
      const raw  = parseFloat($('[name=hip]', form).value);
      const unit = ($('[name=unit]:checked', form) || {}).value || 'in';
      const div  = $('[name=division]', form).value;
      const isTrunk = !!(Z.trunkChart && Z.trunkChart.ranges[div]);
      const lbl = $('[data-measure-lbl]', form);
      if (lbl) lbl.textContent = isTrunk ? 'Measurement around your waist' : 'Measurement around your hips';
      if (!raw || raw <= 0) { out.hidden = true; $$('tbody tr', document).forEach(r => r.classList.remove('is-match')); return; }

      const inches = unit === 'cm' ? raw / 2.54 : raw;
      $$('tbody tr', document).forEach(r => r.classList.remove('is-match'));
      if (isTrunk) return trunks(raw, unit, inches, div);
      let band = Z.hipToSize.find(b => inches >= b.min && inches < b.max);
      let straddles = false;
      if (!band) {
        band = inches < Z.hipToSize[0].min ? Z.hipToSize[0] : Z.hipToSize[Z.hipToSize.length - 1];
      } else {
        // The bands deliberately overlap at the edges. Between two sizes,
        // the client's rule is take the smaller one.
        const overlap = Z.hipToSize.find(b => b !== band && inches >= b.min && inches < b.max);
        if (overlap) { straddles = true; band = overlap.size < band.size ? overlap : band; }
      }

      const advice = Z.divisionAdvice.find(a =>
        a.division.toLowerCase().includes(div.toLowerCase().split(' ')[0]));

      let size = band.size;
      let adjNote = '';
      if (advice) {
        if (advice.advice === 'down' && size > Z.waistSizes[0]) {
          adjNote = `For ${advice.division.toLowerCase()}, we'd size you down to <b>${size - 2}&Prime;</b>. ${advice.why}`;
        } else if (advice.advice === 'up' && size < Z.waistSizes[Z.waistSizes.length - 1]) {
          adjNote = `For ${advice.division.toLowerCase()}, we'd size you up to <b>${size + 2}&Prime;</b>. ${advice.why}`;
        } else if (advice.advice === 'preference') {
          adjNote = `For ${advice.division.toLowerCase()}: ${advice.why}`;
        }
      }

      out.hidden = false;
      settle('size_finder', { size, division: div });
      out.innerHTML = `
        <div class="calc__verdict">Start at ${size}&Prime;</div>
        <p class="small" style="color:var(--ink-2)">
          A ${unit === 'cm' ? raw + 'cm' : raw + '&Prime;'} hip measurement${unit === 'cm' ? ` (${inches.toFixed(1)}&Prime;)` : ''} puts you in the ${size}&Prime; band.
          ${straddles ? `You're between two sizes, so we've taken the smaller one — that's our rule and it's the right call in a stretch fabric.` : ''}
        </p>
        ${adjNote ? `<p class="small mt-1" style="color:var(--ink-2)">${adjNote}</p>` : ''}
        <p class="hint mt-1">Not sure? Send us your measurements before you order. We'd rather check than have you exchange.</p>`;

      $$('tbody tr[data-size]').forEach(r =>
        r.classList.toggle('is-match', +r.dataset.size === size));
    }

    // Trunks sell in letter sizes off Andy's own trunk chart, which leaves a gap between bands
    // (30 to 31 and so on). A measurement in a gap is between two sizes, and her rule there is the larger one.
    // Trunks size off the waist; the Classic Taper has its own single-figure waist chart (Andy, 5 Oct 2026).
    function trunks(raw, unit, inches, div) {
      const T = Z.trunkChart, range = T.ranges[div];
      const name = div === 'Classic' ? 'Classic trunks' : 'Bodybuilding trunks';
      const top = T.bands[T.bands.length - 1];
      let band = T.bands.find(b => inches >= b.min && inches <= b.max);
      const between = !band && inches > T.bands[0].min && inches < top.max;
      if (!band) band = T.bands.find(b => inches < b.min);
      let verdict, why = '';
      if (!band) {
        verdict = range.includes('2XL') ? 'Talk to us about 2XL or 3XL' : 'Talk to us before you order';
        why = `That's above our chart, which tops out at ${top.max}&Prime;. Send us your measurement and we'll tell you which size.`;
      } else if (!range.includes(band.size)) {
        verdict = `Start at ${T.bands.find(b => b.size === range[0]).name}`;
        why = `${name} start at ${T.bands.find(b => b.size === range[0]).name}, so that's the closest fit. Send us your measurement if you're unsure.`;
      } else {
        verdict = `Start at ${band.name}`;
        why = between ? `You're between two sizes, so we've taken the larger one. Trunks are cut smaller than the shorts.` : '';
      }
      const advice = div === 'Classic' && Z.divisionAdvice.find(a => a.advice === 'preference');
      const TP = div === 'Classic' && T.taper;
      let taperNote = '';
      if (TP) {
        const fit = TP.sizes.find(t => inches <= t.waist);
        taperNote = fit
          ? `In the Classic Taper, which has its own chart, start at <b>${fit.name}</b> (${fit.waist}&Prime; waist).`
          : `The Classic Taper tops out at ${TP.sizes[TP.sizes.length - 1].waist}&Prime;. Send us your measurement before you order one.`;
        $$('tbody tr[data-taper]').forEach(r => r.classList.toggle('is-match', !!fit && r.dataset.taper === fit.size));
      }
      out.hidden = false;
      settle('size_finder', { size: band ? band.size : 'above chart', division: div });
      out.innerHTML = `
        <div class="calc__verdict">${verdict}</div>
        <p class="small" style="color:var(--ink-2)">
          A ${unit === 'cm' ? raw + 'cm' : raw + '&Prime;'} waist measurement${unit === 'cm' ? ` (${inches.toFixed(1)}&Prime;)` : ''} on our trunk chart. ${why}
        </p>
        ${taperNote ? `<p class="small mt-1" style="color:var(--ink-2)">${taperNote}</p>` : ''}
        ${advice ? `<p class="small mt-1" style="color:var(--ink-2)">For classic physique: ${advice.why}</p>` : ''}
        <p class="hint mt-1">Not sure? Send us your measurements before you order. We'd rather check than have you exchange.</p>`;
      if (band && range.includes(band.size)) $$(`tbody tr[data-trunk="${band.size}"]`).forEach(r => r.classList.add('is-match'));
    }

    $$('input, select', form).forEach(el => {
      el.addEventListener('change', run);
      el.addEventListener('input', run);
    });
    form.addEventListener('submit', e => { e.preventDefault(); run(); });
  }
  $$('[data-sizer]').forEach(initSizer);

  /* --- product page ------------------------------------------------------
     Builds its own controls from the catalogue so a colourway is data, not a
     hand-written block of HTML per product.
     ---------------------------------------------------------------------- */
  $$('[data-product]').forEach(async (root) => {
    const [cat, site] = await Promise.all([
      fetch(VA_DATA('assets/data/catalogue.json')).then(r => r.json()).then(VA_FIX)
        .then(c => window.VA_SHOP ? VA_SHOP.live(c) : c),
      siteReady,
    ]).catch(() => [null, null]);
    if (!cat || !SITE) return;
    const coll = cat.collections.find(c => c.handle === root.dataset.product);
    if (!coll) return;

    const esc = (s) => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    // Only the shorts come in lengths; trunks have none, so no picker and no length on the variant.
    const lengths = coll.lengths || [];
    const advice = SITE.sizing.divisionAdvice.find(a =>
      (coll.sizeAdvice === 'down' && a.advice === 'down') ||
      (coll.sizeAdvice === 'up' && a.advice === 'up') ||
      (coll.sizeAdvice === 'preference' && a.advice === 'preference'));

    const optionLabel = coll.optionLabel || 'Colourway';
    // Live store sizes win: trunks sell in letters (S to 3XL), shorts by waist.
    const live = window.VA_SHOP && VA_SHOP.sizes ? VA_SHOP.sizes(coll) : [];
    const sizeList = live.length ? live : SITE.sizing.waistSizes;
    const lettered = sizeList.some(s => typeof s === 'string');
    const sizeName = (s) => lettered ? `Size ${s}` : `${s}&Prime; waist`;
    const inch = lettered ? '' : '&Prime;';
    // A shop card links to page.html#<handle>, which opens on that colourway.
    // On Shopify a /products/<handle> URL arrives with the colourway in VA_PICK instead,
    // and a bag line or order email adds ?variant=<id>, which also picks the size and length.
    const hashPick = decodeURIComponent(location.hash.slice(1));
    const fromPick = coll.products.findIndex(p => p.handle === (hashPick || window.VA_PICK));
    const vid = +new URLSearchParams(location.search).get('variant') || 0;
    const fromVariant = vid ? coll.products.findIndex(p => (p.variants || []).some(v => +v.id === vid)) : -1;
    const byVariant = fromVariant >= 0 && !(hashPick && fromPick >= 0);
    const state = { i: Math.max(0, byVariant ? fromVariant : fromPick), length: lengths[0] ?? null, size: null, shot: 0 };
    if (byVariant) {
      const v0 = coll.products[fromVariant].variants.find(v => +v.id === vid);
      if (v0.size != null && sizeList.some(s => String(s) === String(v0.size))) state.size = v0.size;
      if (v0.length != null && lengths.includes(v0.length)) state.length = v0.length;
    }
    const item = () => ({ currency: 'AUD', value: coll.price, items: [{
      item_id: coll.products[state.i].handle, item_name: coll.title, item_variant: coll.products[state.i].title,
      item_category: coll.handle, price: coll.price, quantity: 1 }] });
    const viewItem = () => vaSend('view_item', item());

    root.innerHTML = `
      <div class="split split--wide">
        <div class="cfg__preview">
          <div class="cfg__stage pgal" data-stage>
            <div class="pgal__track" data-track tabindex="0" aria-roledescription="carousel"
                 aria-label="${esc(coll.title)} photographs. Arrow keys change the view."></div>
            <p class="pgal__call" data-call aria-live="polite"></p>
            <button class="pgal__step pgal__step--prev" type="button" data-step="-1" aria-label="Previous photograph"></button>
            <button class="pgal__step pgal__step--next" type="button" data-step="1" aria-label="Next photograph"></button>
          </div>
          <div class="pgal__calls" data-calls></div>
          <div class="cfg__meta" data-meta></div>
        </div>
        <div>
          <p class="eyebrow" data-pname></p>
          <h1 class="t2">${esc(coll.title)}</h1>
          <p class="lede mt-2">${esc(coll.blurb)}</p>
          <p style="font-family:var(--f-d);font-size:2.2rem;margin-top:18px" data-price>$${coll.price}</p>

          <div class="field mt-2">
            <span class="lbl">${esc(optionLabel)}</span>
            <div class="choices">
              ${coll.products.map((p, i) => `
                <label class="choice">
                  <input type="radio" name="colourway" value="${i}" ${i === state.i ? 'checked' : ''}>
                  <span><i class="swatch" style="background:${p.swatch}"></i>${esc(p.title)}</span>
                </label>`).join('')}
            </div>
          </div>

          <div class="field">
            <span class="lbl">${lettered ? 'Size' : 'Waist size'}</span>
            <div class="choices">
              ${sizeList.map(w => `
                <label class="choice">
                  <input type="radio" name="psize" value="${esc(w)}" ${String(w) === String(state.size) ? 'checked' : ''}>
                  <span>${esc(w)}${inch}</span>
                </label>`).join('')}
            </div>
            <p class="hint mt-1">
              ${advice ? `<b style="color:var(--acc-tx)">${advice.advice === 'down' ? 'Size down' : advice.advice === 'up' ? 'Size up' : 'Your call'}</b> for this one. ${esc(advice.why)} ` : ''}
              <a href="${VA_PAGE('sizing.html')}" style="color:var(--acc-tx)">Work out your size</a>.
            </p>
          </div>

          ${lengths.length > 1 ? `
          <div class="field">
            <span class="lbl">Length</span>
            <div class="choices">
              ${lengths.map((l, i) => `
                <label class="choice">
                  <input type="radio" name="plength" value="${l}" ${l === state.length ? 'checked' : ''}>
                  <span>${l}&Prime;</span>
                </label>`).join('')}
            </div>
          </div>` : ''}

          <div data-buy hidden>
            <button class="btn btn--wide" type="button">Add to bag</button>
            <p class="hint mt-1">Dispatched in ${SITE.turnaround.inStockDispatchDaysMin}–${SITE.turnaround.inStockDispatchDaysMax} business days. Free shipping over $${SITE.shipping.freeThreshold}.</p>
          </div>

          <form data-notify hidden data-confirm="You're on the list. We'll email you the moment this exact size and colour is back."
                name="back-in-stock" method="POST" data-netlify="true" netlify-honeypot="bot-field">
            <input type="hidden" name="form-name" value="back-in-stock">
            <p hidden><label>Leave blank <input name="bot-field" tabindex="-1" autocomplete="off"></label></p>
            <input type="hidden" name="referralCode"><input type="hidden" name="referralSource"><input type="hidden" name="referralLanding">
            <input type="hidden" name="variant" data-variant>
            <div class="card card--acc">
              <h3>Sold out — want to know when it's back?</h3>
              <p class="mb-2">We're restocking most of the range. Tell us your email and we'll let you know when
              this exact size and colour lands. Not a newsletter.</p>
              <div class="field" style="margin-bottom:12px">
                <label class="sr-only" for="notify-email">Email</label>
                <input class="input" type="email" id="notify-email" name="email" placeholder="you@email.com" required>
              </div>
              <button class="btn btn--wide" type="submit">Notify me</button>
            </div>
          </form>

          <div class="pills mt-2">
            <span class="pill">Sizes ${esc(sizeList[0])}${inch}–${esc(sizeList[sizeList.length - 1])}${inch}</span>
            <span class="pill">4-way stretch</span>
            <span class="pill">Made for the stage</span>
          </div>
          <p class="hint mt-2">
            Legal in IFBB, ICN, NABBA, WNBF and INBA. Not ANB or NBA — they require their own stagewear.
            <a href="${VA_PAGE('federations.html')}" style="color:var(--acc-tx)">The detail</a>.
          </p>
        </div>
      </div>`;

    /* The gallery runs like a judging round: the panel's calls (front, the
       quarter turns, back), then the close-ups. One swipe track on phones; the
       same track with the numbered calls under it on desktop. */
    const track = $('[data-track]', root);
    const pad = n => String(n).padStart(2, '0');
    const shots = () => {
      const p = coll.products[state.i];
      return p.gallery?.length ? p.gallery
        : [{ src: p.imgLarge || p.img, thumb: p.img, label: p.title, kind: 'view' }];
    };
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');

    const seenKinds = new Set();
    const mark = () => {
      const list = shots(), s = list[state.shot];
      // Which photos people actually open, the on-stage ones above all. Shot 0
      // is shown on load, so only a move away from it counts.
      const kindKey = coll.products[state.i].handle + ':' + (s.kind || 'view');
      if (state.shot > 0 && !seenKinds.has(kindKey)) {
        seenKinds.add(kindKey);
        vaSend('gallery_view', { photo_kind: s.kind || 'view', ...item() });
      }
      $('[data-call]', root).innerHTML =
        `<b>${pad(state.shot + 1)}</b><span>/${pad(list.length)}</span> ${esc(s.label)}`;
      $$('[data-shot]', root).forEach(b =>
        b.setAttribute('aria-current', +b.dataset.shot === state.shot ? 'true' : 'false'));
      // Load the neighbours early so a swipe never lands on a blank frame.
      $$('.pgal__slide img', track).forEach((img, k) => {
        if (Math.abs(k - state.shot) <= 1) img.loading = 'eager';
      });
    };
    const showShot = (n, smooth) => {
      const len = shots().length;
      state.shot = (n + len) % len;
      // Slide positions, not index × width: the track's width can be fractional.
      track.scrollTo({ left: track.children[state.shot].offsetLeft,
                       behavior: smooth && !reduced.matches ? 'smooth' : 'auto' });
      mark();
    };

    const paintGallery = () => {
      const p = coll.products[state.i], list = shots();
      track.innerHTML = list.map((s, k) => `
        <figure class="pgal__slide pgal__slide--${s.kind || 'view'}" aria-roledescription="slide"
                aria-label="${k + 1} of ${list.length}: ${esc(s.label)}">
          <img class="pstage__img" src="${s.src}" alt="${esc(coll.title)}, ${esc(p.title)}, ${s.kind === 'stage' ? 'worn on stage' : esc(s.label.toLowerCase())}"
               width="${s.w || 1200}" height="${s.h || 1200}" decoding="async" ${k > 1 ? 'loading="lazy"' : ''}>
        </figure>`).join('');
      // One row per kind, in the order the kinds first appear. The first on-stage
      // shot sits second in the track, so its row follows the studio views' row.
      const views = list.filter(s => (s.kind || 'view') === 'view').length;
      const names = { view: views === 4 ? 'Quarter turns' : 'Front and back', stage: 'On stage', detail: 'Close-ups' };
      const kinds = [...new Set(list.map(s => s.kind || 'view'))];
      const group = kind => `
        <div class="pgal__group">
          <span class="pgal__gname">${names[kind] || kind}</span>
          <div class="pgal__row">
            ${list.map((s, k) => [s, k]).filter(([s]) => (s.kind || 'view') === kind).map(([s, k]) => `
              <button type="button" class="pgal__pick" data-shot="${k}" title="${esc(s.label)}"
                      aria-label="${pad(k + 1)}, ${esc(s.label)}">
                <img src="${s.thumb}" alt="" width="180" height="180" loading="lazy" decoding="async">
                <b>${pad(k + 1)}</b>
              </button>`).join('')}
          </div>
        </div>`;
      $('[data-calls]', root).innerHTML = list.length > 1 ? kinds.map(group).join('') : '';
      $$('[data-shot]', root).forEach(b => b.addEventListener('click', () => showShot(+b.dataset.shot, true)));
      $('.pgal', root).classList.toggle('is-single', list.length < 2);
      state.shot = 0;
      track.scrollLeft = 0;
      mark();
    };

    // Swipes and trackpad scrolls move the track directly; follow them.
    let settle;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(settle);
      settle = requestAnimationFrame(() => {
        const n = Math.round(track.scrollLeft / Math.max(1, track.children[0]?.getBoundingClientRect().width || 1));
        if (n !== state.shot && n < shots().length) { state.shot = n; mark(); }
      });
    }, { passive: true });
    $$('[data-step]', root).forEach(b =>
      b.addEventListener('click', () => showShot(state.shot + +b.dataset.step, true)));
    $('.pgal', root).addEventListener('keydown', e => {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      showShot(state.shot + (e.key === 'ArrowRight' ? 1 : -1), true);
    });
    // The track is sized by the viewport; keep the current shot in frame on resize.
    addEventListener('resize', () => { track.scrollLeft = track.children[state.shot]?.offsetLeft || 0; });

    const paint = () => {
      const p = coll.products[state.i];
      $('[data-pname]', root).textContent = p.note ? `${p.title} · ${p.note}` : p.title;

      const map = { in: ['In stock', 'pill--in'], low: ['Low stock', 'pill--low'], out: ['Sold out', 'pill--out'] };
      // Live store: the chosen size and length decide stock and price. Sizes with nothing
      // left are struck through (still selectable, so the notify form can open); sizes this
      // colourway was never made in are hidden, because the size list covers the whole collection.
      const shop = window.VA_SHOP && p.variants;
      if (shop) {
        $$('[name=psize]', root).forEach(el => {
          const x = VA_SHOP.variant(p, el.value, state.length), made = !!x || !p.variants.length;
          el.closest('.choice').style.display = made ? '' : 'none';
          el.closest('.choice').toggleAttribute('data-gone', !(x && x.available));
          if (!made && el.checked) { el.checked = false; state.size = null; }
        });
      }
      const v = shop ? VA_SHOP.variant(p, state.size, state.length) : null;
      const stock = shop && state.size ? (v && v.available ? 'in' : 'out') : p.stock;
      if (shop) $('[data-price]', root).textContent = '$' + (v ? v.price : p.price ?? coll.price);
      const [txt, cls] = map[stock] || map.out;
      $('[data-meta]', root).innerHTML =
        `<span class="pill ${cls}">${txt}</span>` +
        `<span class="pill">${state.size ? sizeName(state.size) : 'Pick a size'}</span>` +
        (lengths.length > 1 ? `<span class="pill">${state.length}&Prime; length</span>` : '');

      const out = stock === 'out';
      $('[data-notify]', root).hidden = !out;
      $('[data-buy]', root).hidden = out;
      const vf = $('[data-variant]', root);
      if (vf) vf.value = `${coll.title} / ${p.title} / ${state.size ? state.size + (/^\d+$/.test(state.size) ? 'in' : '') : 'size not chosen'}${lengths.length > 1 ? ` / ${state.length}in` : ''}`;
    };

    $$('[name=colourway]', root).forEach(el =>
      el.addEventListener('change', () => {
        state.i = +el.value; paint(); paintGallery(); viewItem();
        history.replaceState(null, '', '#' + coll.products[state.i].handle);
      }));
    // A #handle link to the page you are already on (the footer, a shared link
    // pasted into the same tab) changes only the hash; follow it.
    addEventListener('hashchange', () => {
      const i = coll.products.findIndex(p => p.handle === decodeURIComponent(location.hash.slice(1)));
      const el = $(`[name=colourway][value="${i}"]`, root);
      if (i < 0 || i === state.i || !el) return;
      el.checked = true; state.i = i; paint(); paintGallery(); viewItem();
    });
    $$('[name=plength]', root).forEach(el =>
      el.addEventListener('change', () => { state.length = +el.value; paint(); }));
    $$('[name=psize]', root).forEach(el =>
      el.addEventListener('change', () => { state.size = lettered ? el.value : +el.value; paint(); }));

    paint();
    paintGallery();
    viewItem();
    // On Netlify there is no cart: the click still tells us which size and colour people
    // wanted. On Shopify it adds the exact variant to the real bag.
    const buy = $('[data-buy] button', root), buyNote = $('[data-buy] .hint', root), buyText = buy.textContent;
    buy.addEventListener('click', async () => {
      const p = coll.products[state.i];
      const track = () => vaSend('add_to_cart', { currency: 'AUD', value: p.price ?? coll.price,
        items: [{ ...item().items[0], item_variant: `${p.title} / ${state.size || 'no size'}${state.length ? ` / ${state.length}in` : ''}` }] });
      if (!window.VA_SHOP || !p.variants) return track();
      if (!state.size) {
        buyNote.textContent = lettered ? 'Pick a size first.' : 'Pick a waist size first.';
        $('[name=psize]', root).focus();
        return;
      }
      const v = VA_SHOP.variant(p, state.size, state.length);
      if (!v || !v.available) return paint();
      buy.disabled = true; buy.textContent = 'Adding…';
      try {
        await VA_SHOP.add([{ id: v.id, quantity: 1 }]);
        track();
        buy.textContent = 'Added to your bag';
        buyNote.innerHTML = `<a href="${VA_SHOP.cartUrl}" style="color:var(--acc-tx)">View your bag and check out</a>, or keep shopping.`;
      } catch (e) {
        buy.textContent = buyText;
        // Shopify's stock refusals ("All 1 ... are in your cart.") say why; retrying won't help those.
        const msg = String(e.message || '').trim().replace(/[.!]+$/, '').replace(/\bcart\b/gi, 'bag');
        buyNote.textContent = /quantity|in your bag|more|sold out|stock/i.test(msg)
          ? `${msg}. That's all we have in this size right now.`
          : `${msg || "That didn't go through"}. Please try again, or email info@visionattire.com.au.`;
      } finally {
        buy.disabled = false;
        setTimeout(() => { if (buy.textContent === 'Added to your bag') buy.textContent = buyText; }, 2500);
      }
    });
    $$('form[data-confirm]', root).forEach(f => { shopifyPrep(f); f.addEventListener('submit', confirmHandler); });
  });

  /* --- attribution ---------------------------------------------------------
     Partner referral codes and the expo QR source. Captured once from the
     URL, kept for 30 days, and carried through to whichever enquiry form the
     visitor eventually fills in — the click and the form are rarely the same
     visit.
     ---------------------------------------------------------------------- */
  const ATTR_KEY = 'va-attribution-v1';
  const ATTR_DAYS = 30;
  const ATTR_LABELS = { 'cbr-expo-2026': 'CBR Fitness Expo 2026' };

  function attrRead() {
    try {
      const raw = localStorage.getItem(ATTR_KEY);
      if (!raw) return null;
      const rec = JSON.parse(raw);
      if (!rec || typeof rec !== 'object' || typeof rec.expires !== 'number') return null;
      if (Date.now() > rec.expires) {
        try { localStorage.removeItem(ATTR_KEY); } catch {}
        return null;
      }
      return rec;
    } catch { return null; }
  }

  function attrWrite(rec) {
    try { localStorage.setItem(ATTR_KEY, JSON.stringify(rec)); } catch {}
  }

  function attrLabel(rec) {
    if (!rec || !rec.source) return '';
    return ATTR_LABELS[rec.source] || rec.source;
  }

  (function initAttribution() {
    const cleanRef = (v) => (v || '').replace(/[^A-Za-z0-9_-]/g, '').slice(0, 40).toUpperCase();
    const cleanSrc = (v) => (v || '').toLowerCase().replace(/[^a-z0-9-]/g, '').slice(0, 60);
    const params = new URLSearchParams(location.search);
    const ref = cleanRef(params.get('ref'));
    const src = cleanSrc(params.get('src') || params.get('utm_source'));
    const campaign = cleanSrc(params.get('utm_campaign'));

    if (ref || src) {
      // Last touch wins: a fresh ref/source in the URL replaces whatever was
      // stored before, rather than merging with it.
      const now = Date.now();
      attrWrite({
        ref: ref || null,
        source: src || null,
        campaign: campaign || null,
        landing: (location.pathname + location.search).slice(0, 200),
        firstSeen: new Date(now).toISOString(),
        expires: now + ATTR_DAYS * DAY,
      });
    } else {
      // No new ref/source on this load: leave any existing record alone,
      // except that reading it here clears it out once it's past 30 days.
      attrRead();
    }
  })();

  window.VA_ATTRIBUTION = {
    get: attrRead,
    sourceLabel: () => attrLabel(attrRead()),
    apply(form) {
      if (!form) return;
      const rec = attrRead();
      const label = attrLabel(rec);
      const set = (name, value) => {
        const el = $(`[name=${name}]`, form);
        if (el) el.value = value || '';
      };
      set('referralCode', rec && rec.ref);
      set('referralSource', rec && rec.campaign ? `${label} / ${rec.campaign}` : label);
      set('referralLanding', rec && rec.landing);
    },
  };

  $$('form[data-netlify]').forEach(f => window.VA_ATTRIBUTION.apply(f));

  const attrNote = $('[data-attribution-note]');
  if (attrNote) {
    const noteLabel = window.VA_ATTRIBUTION.sourceLabel();
    if (noteLabel) {
      attrNote.hidden = false;
      attrNote.textContent = `You found us through ${ATTR_LABELS[window.VA_ATTRIBUTION.get()?.source] ? 'the ' : ''}${noteLabel}. We’ll note that on your application.`;
    }
  }

  /* --- forms -------------------------------------------------------------
     Netlify Forms handles these on deploy with no backend. On Shopify
     (VA_FORMS 'shopify') they post to the store's own contact form instead,
     which emails the store and can't carry files. Locally there is nothing
     to post to, so confirm in the UI rather than throwing an error at
     someone reviewing the build.
     ---------------------------------------------------------------------- */
  const SHOPIFY_FORMS = window.VA_FORMS === 'shopify';
  const SENT_KEY = 'va-contact-sent';
  const LABELS = { okFederation: 'Federation note confirmed', okCopyright: 'Artwork confirmed as their own',
    photoConsent: 'Photo consent', spec: 'Design specification' };
  const SKIP = new Set(['form-name', 'bot-field', 'form_type', 'utf8', 'h-captcha-response', 'g-recaptcha-response']);
  // Declarations rather than consts: the product page draws its back-in-stock form before this part of the file runs.
  function hiddenInput(name, value) { return Object.assign(document.createElement('input'), { type: 'hidden', name, value }); }
  const isLocal = () => ['localhost', '127.0.0.1'].includes(location.hostname) || location.protocol === 'file:';

  // Turns a site form into a Shopify contact form. The store's captcha guards any form that posts to /contact
  // with form_type=contact, checked when it is submitted, so forms drawn later by JS are covered too.
  function shopifyPrep(form) {
    if (window.VA_FORMS !== 'shopify' || form.dataset.shopify) return;
    form.dataset.shopify = 'true';
    form.setAttribute('action', '/contact');
    form.setAttribute('method', 'post');
    form.setAttribute('accept-charset', 'UTF-8');
    form.enctype = 'application/x-www-form-urlencoded';
    form.prepend(hiddenInput('form_type', 'contact'), hiddenInput('utf8', '✓'));
    const fileFields = [...new Set([...form.querySelectorAll('input[type=file]')].map(i => i.closest('.field') || i))];
    if (!fileFields.length) return;
    form.dataset.hadFiles = 'true';
    const note = document.createElement('p');
    note.className = 'small muted';
    note.dataset.filesNote = '';
    const what = { 'size-help': 'photos', 'custom-order': 'artwork, logos or reference images' }[form.getAttribute('name')] || 'files';
    note.innerHTML = `Email your ${what} to ` +
      '<a href="mailto:info@visionattire.com.au">info@visionattire.com.au</a> once you\'ve sent this, and we\'ll match them to your request.';
    fileFields[0].replaceWith(note);
    fileFields.slice(1).forEach(f => f.remove());
  }

  // Writes every answer into contact[Label] fields, the only ones Shopify puts in the email.
  function contactFields(form) {
    form.querySelectorAll('[data-contact]').forEach(i => i.remove());
    const name = form.getAttribute('name') || 'contact';
    const fields = new Map([['Form', name.charAt(0).toUpperCase() + name.slice(1).replace(/-/g, ' ')]]);
    for (const [k, v] of new FormData(form)) {
      if (SKIP.has(k) || k.startsWith('contact[') || typeof v !== 'string' || !v.trim()) continue;
      const label = k === 'email' ? 'email' : LABELS[k] ||
        k.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/[-_]/g, ' ').toLowerCase().replace(/^./, c => c.toUpperCase());
      const value = v === 'on' ? 'yes' : v.trim();
      fields.set(label, fields.has(label) ? fields.get(label) + ', ' + value : value);
    }
    if (form.dataset.hadFiles) fields.set('Files', 'Asked to email any files to info@visionattire.com.au');
    for (const [label, value] of fields) {
      const input = hiddenInput(`contact[${label}]`, value);
      input.dataset.contact = '';
      form.append(input);
    }
  }

  // No preventDefault on the way out: the browser posts to /contact, the store's captcha may step in first, and
  // Shopify sends the shopper back to this page with ?contact_posted=true, where the banner below picks it up.
  function shopifySubmit(e, form) {
    if (form.dataset.sending === 'true') return;   // the captcha re-submitting once it has a token
    if (form.dataset.sent === 'true' || form.elements['bot-field']?.value) { e.preventDefault(); return; }
    shopifyPrep(form);
    if (window.VA_ATTRIBUTION) window.VA_ATTRIBUTION.apply(form);
    contactFields(form);
    form.querySelectorAll('.note[role=status]').forEach(n => n.remove());
    const box = Object.assign(document.createElement('div'), { className: 'note mt-2' });
    box.setAttribute('role', 'status');
    form.appendChild(box);
    if (isLocal()) { e.preventDefault(); box.textContent = 'Local preview: nothing has been sent. Your details are still here.'; return; }
    try { sessionStorage.setItem(SENT_KEY, JSON.stringify({ form: form.getAttribute('name'), confirm: form.dataset.confirm, at: Date.now() })); } catch {}
    form.dataset.sending = 'true';
    const button = form.querySelector('[type=submit]');
    if (button) button.textContent = 'Sending…';
    box.textContent = 'Sending your request. Please keep this page open.';
  }

  if (SHOPIFY_FORMS) {
    let sent = null;
    try { sent = JSON.parse(sessionStorage.getItem(SENT_KEY) || 'null'); sessionStorage.removeItem(SENT_KEY); } catch {}
    const url = new URL(location.href);
    const posted = url.searchParams.get('contact_posted') === 'true';
    const main = $('main');
    if (main && (posted || (sent && Date.now() - sent.at < 15 * 60 * 1000))) {
      const box = Object.assign(document.createElement('div'), { className: 'note' });
      box.setAttribute('role', 'status');
      if (posted) {
        box.textContent = sent?.confirm || "Thanks, your message is with the Vision Attire team. We'll reply by email.";
        vaSend('generate_lead', { form_name: sent?.form || 'contact', referral_source: window.VA_ATTRIBUTION?.get()?.source || '(none)' });
      } else {
        box.className = 'note note--warn';
        box.append('Your request was not confirmed as received. Please send it again, or email ',
          Object.assign(document.createElement('a'), { href: 'mailto:info@visionattire.com.au', textContent: 'info@visionattire.com.au' }), '.');
        vaSend('form_error', { form_name: sent.form });
      }
      const wrap = Object.assign(document.createElement('div'), { className: 'wrap' });
      wrap.style.paddingTop = '24px';
      wrap.append(box);
      main.prepend(wrap);
      url.searchParams.delete('contact_posted');
      history.replaceState(history.state, '', url.pathname + url.search);
    }
  }

  async function confirmHandler(e) {
    const form = e.currentTarget;
    if (e.defaultPrevented || !form.checkValidity()) return;
    if (SHOPIFY_FORMS) return shopifySubmit(e, form);
    e.preventDefault();
    if (form.dataset.sending === 'true' || form.dataset.sent === 'true') return;
    const fileBytes = [...form.querySelectorAll('input[type=file]')]
      .reduce((t, i) => t + [...i.files].reduce((s, f) => s + f.size, 0), 0);
    if (fileBytes > 5 * 1024 * 1024) {
      form.querySelectorAll('.note[role=status]').forEach(n => n.remove());
      const warn = Object.assign(document.createElement('div'), { className: 'note mt-2',
        textContent: `Your files come to ${(fileBytes / 1048576).toFixed(1)} MB and the limit is 5 MB in total. ` +
          'Please send smaller files, or send the form without them and email them to info@visionattire.com.au.' });
      warn.setAttribute('role', 'status');
      form.appendChild(warn);
      return;
    }
    if (window.VA_ATTRIBUTION) window.VA_ATTRIBUTION.apply(form);
    const local = ['localhost', '127.0.0.1'].includes(location.hostname) || location.protocol === 'file:';
    const box = document.createElement('div');
    box.className = 'note mt-2';
    box.setAttribute('role', 'status');
    form.querySelectorAll('.note[role=status]').forEach(n => n.remove());
    form.appendChild(box);
    if (local) { box.textContent = 'Local preview: nothing has been sent. Your details are still here.'; return; }
    const button = form.querySelector('[type=submit]'), label = button?.textContent;
    const data = new FormData(form);
    data.set('form-name', form.getAttribute('name'));
    form.dataset.sending = 'true';
    if (button) { button.disabled = true; button.textContent = 'Sending…'; }
    box.textContent = 'Sending your request. Please keep this page open.';
    const controller = new AbortController(), timeout = setTimeout(() => controller.abort(), 30000);
    try {
      const multipart = form.enctype === 'multipart/form-data';
      // On Shopify the theme points VA_FORMS at the Netlify relay; forms still land in Netlify.
      const response = await fetch(window.VA_FORMS || '/', {
        method: 'POST',
        headers: multipart ? {} : {'Content-Type': 'application/x-www-form-urlencoded'},
        body: multipart ? data : new URLSearchParams(data), signal: controller.signal,
      });
      if (!response.ok) throw new Error(response.status === 413 ? 'too large' : 'Submission failed');
      form.dataset.sent = 'true';
      box.textContent = form.dataset.confirm;
      vaSend('generate_lead', { form_name: form.getAttribute('name'),
        referral_source: window.VA_ATTRIBUTION?.get()?.source || '(none)' });
      if (button) button.textContent = 'Request sent';
    } catch (err) {
      vaSend('form_error', { form_name: form.getAttribute('name') });
      box.textContent = err && err.message === 'too large'
        ? 'Your files are too large to send. Please send smaller versions, or send this without them and email them to us. '
        : 'Your request was not confirmed as received. Your details are still here. Please try again, or email us. ';
      if (button) { button.disabled = false; button.textContent = label; }
      const custom = form.getAttribute('name') === 'custom-order';
      const email = document.createElement('a');
      email.textContent = custom ? 'Email this design request' : 'Email info@visionattire.com.au';
      email.href = 'mailto:info@visionattire.com.au?subject=' + encodeURIComponent(custom ? 'Custom shorts design request' : 'Website enquiry') +
        (custom ? '&body=' + encodeURIComponent(data.get('spec') || '') : '');
      box.append(email);
    } finally { clearTimeout(timeout); delete form.dataset.sending; }
  }
  window.__vaConfirm = confirmHandler;
  // Forms drawn later (the builder, back-in-stock, drop waitlist) wire themselves through this.
  window.__vaWire = form => { shopifyPrep(form); form.addEventListener('submit', confirmHandler); };
  $$('form[data-confirm]').forEach(window.__vaWire);

  /* --- year --------------------------------------------------------------- */
  $$('[data-year]').forEach(el => el.textContent = new Date().getFullYear());
})();
